namespace('compass.hotel');

compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.hotel.GDSPoliciesWidget = compass.defineWidget(function GDSPoliciesWidget(options) {
    var me = this;
    var $j = jQuery;

    var _settings = options;
    var _policies = $j.isArray(_settings.policies.gdsHotelPolicies) ? _settings.policies.gdsHotelPolicies :
        [_settings.policies.gdsHotelPolicies];

    var _formatNumber = compass.util.phoneFormatter({}) || {};

    var _render = this.render = function(widgetElem) {

        var d = _d;
        var _defaultPhone = '(800) 355 8093';
        var _phone = _settings.phone ? _formatNumber(_settings.phone) : _formatNumber(_defaultPhone);
        var holderDiv = d.div({className:'policiesDiv'});
        holderDiv.append(
            me.drawPolicyHeader()
        );
        for (var i=0; i < _policies.length; i++) {
            holderDiv.append(
                me.drawHotelNameHeader(i, _policies[i].roomName)
            );
            
            if (_policies[i].roomName) {
              holderDiv.append(
                me.drawRoomName(i)
              );
            }

            // Changes and Cancellation Policy
            holderDiv.append(
            me.drawCancelVerbiageHeader()
            );

            holderDiv.append(
            me.drawCancelVerbiage(_phone)
            );


            if (_policies[i].refundable === false) {
              holderDiv.append(
                me.drawRefundableNote(i, _policies[i])
              );
            }
            
            if (_policies[i].depositPolicy && _policies[i].depositPolicy.length > 0) {
              holderDiv.append(
                me.drawDepositPolicyHeader()
              );
              for(var policyIndex=0; policyIndex < _policies[i].depositPolicy.length; policyIndex++ ) {
                holderDiv.append(
                  me.drawDepositPolicies(i, policyIndex)
                );
              }
            }

            if (_policies[i].cancelPolicy && _policies[i].cancelPolicy.length > 0) {
              holderDiv.append(
                me.drawCancelPolicyHeader()
              );
              for(var policyIndex=0; policyIndex < _policies[i].cancelPolicy.length; policyIndex++ ) {
                holderDiv.append(
                  me.drawCancelPolicies(i, policyIndex)
                );
              }
            }

            if (_policies[i].checkinBeginTime || _policies[i].checkoutTime ||_policies[i].checkinMinAge || _policies[i].checkinInstructions) {
              holderDiv.append(
                  me.drawCheckinAndCheckoutPolicyHeader()
              );
            }

            if (_policies[i].checkinTwentyFourHour) {
              holderDiv.append(
                me.drawCheckinTwentyFourHour(i)
              );
            }

            if (_policies[i].checkinBeginTime.length > 0 || _policies[i].checkinEndTime.length > 0) {
              holderDiv.append(
                  me.drawCheckinAndCheckoutPolicy(i)
              );
            }

            if (_policies[i].checkoutTime) {
              holderDiv.append(
                  me.drawCheckoutPolicy(i)
              );
            }

            if (_policies[i].checkinMinAge) {
              holderDiv.append(
                  me.drawCheckinMinAgePolicy(i)
              );
            }

            if (_policies[i].checkinInstructions) {
              holderDiv.append(
                  me.drawCheckinInstructionsPolicy(i)
              );
            }

            if (_policies[i].checkinSpecialInstructions) {
              holderDiv.append(
                  me.drawCheckinSpecialInstructionsPolicy(i)
              );
            }

            if (_policies[i].mandatoryFees) {
              holderDiv.append(
                  me.drawMandatoryHotelFeesPolicyHeader(),
                  me.drawMandatoryHotelFeesPolicy(i)
              );
            }

            if (_policies[i].knowBeforeYouGo || _policies[i].petPolicies || _policies[i].generalPolicies) {
              holderDiv.append( //only append this header if any of these 3 policy types are present
                  me.drawAdditionalInformationPolicyHeader()
              );
            }

            if (_policies[i].knowBeforeYouGo) {
              holderDiv.append(
                  me.drawKnowBeforeYouGoPolicy(i)
              );
            }

            if (_policies[i].petPolicies) {
              holderDiv.append(
                  me.drawPetPolicy(i)
              );
            }
            
            if (_policies[i].generalPolicies) {
              holderDiv.append(
                  me.drawGeneralPolicy(i)
              );
            }

            if (_policies[i].optionalFees) {
              holderDiv.append(
                  me.drawOptionalExtrasPolicyHeader(),
                  me.drawOptionalExtrasPolicy(i)
              );
            }
        }

        widgetElem.append(holderDiv);
    };

    this.drawPolicyHeader = function() {
        var d = _d;
        return d.div({className:'policyHeader'},
            d.h3({className:'policyHeaderText'}, 'Policies'));
    };

    this.drawHotelNameHeader = function(i, roomName) {
        var d = _d;
        var breakLine = "";
        if (!roomName) {
            breakLine = d.div({className: 'breakLine'});
        }
        return d.div({
            className: 'policyHeader hotelNameHeader'
        }, _policies[i].hotelName, breakLine);
    };

    this.drawRoomName = function(i) {
        var d = _d;
        return d.div({
            className: 'roomNameHeader'
        }, _policies[i].roomName);
    };

    this.drawCancelVerbiageHeader = function() {
        var d = _d;
        return d.div({
            className: "policyHeader cancelVerbiageHeader"
          }, "Changes and Cancellations");
      };

      this.drawCancelVerbiage = function(_phone) {
        var d = _d;
        var text = "";
        if (_settings.affiliateHandledByOurAgent) {
            text = `To make changes to your reservation, please call us directly at ${_phone} between 8:00 AM and 4:30 PM Central Time USA, Monday - Friday.  If you are outside the US, call our international number at +1 (312) 527-7300. It is your responsibility to cancel your reservation, prior to the cancellation deadline in your hotel policy, directly with onPeak by calling during our business hours as noted above.`;
          } else {
            text = "To make changes to your reservation, call to speak with an agent at (877) 502-7827. If you are outside the US, call our international number at +1 (417) 521-1279. Please have your Itinerary ID number ready. It can be found in your confirmation email. Please note any changes made with an agent will not be reflected online.";
          }
        return d.div({
            className: "policyText cancelVerbiage"
          }, text);
      };

    this.drawRefundableNote = function(i, policies) {
        var d = _d;
        var text = "";
        if (policies.cancelPolicy && policies.cancelPolicy.length > 0) {
            text = "Cancellation penalties are non-refundable.";
        } else if (policies.depositPolicy && policies.depositPolicy.length > 0) {
            text = "Deposits are non-refundable.";
        } else {
            text = "If you cancel your reservation, you will not get a refund or credit to use for a future stay.";
        }
        return d.div({
            className: 'policyText refundableNote'
        }, text);
    };

    this.drawDepositPolicyHeader = function() {
        var d = _d;
        return d.div({
            className: 'policyHeader depositPolicyHeader'
        }, "Deposit Policy");
    };

    this.drawDepositPolicies = function(i, j) {
        var d = _d;
        return d.div({
            className: 'policyText depositPolicy'
        }, _policies[i].depositPolicy[j]);
    };

    this.drawCancelPolicyHeader = function() {
        var d = _d;
        return d.div({
            className: 'policyHeader cancelPolicyHeader'
        }, "Cancel Policy");
    };

    this.drawCancelPolicies = function(i, j) {
        var d = _d;
        return d.div({
            className: 'policyText cancelPolicy'
        }, _policies[i].cancelPolicy[j]);
    };

    this.drawCheckinAndCheckoutPolicyHeader = function() {
        var d = _d;
        return d.div({
            className: 'policyHeader checkinandCheckoutPolicyHeader'
        }, "Check-in and Check-out Information");
    };
    
    this.drawCheckinTwentyFourHour = function(i) {
      var d = _d;
      var checkinTwentyFourHourText = "This hotel offers " + _policies[i].checkinTwentyFourHour;
      return d.div({
        className: 'policyText'
      }, checkinTwentyFourHourText);
    };

    this.drawCheckinAndCheckoutPolicy = function(i) {
        var d = _d;
        var checkin = '';
        if (_policies[i].checkinBeginTime.length > 0) {
            checkin += "Check-in starts at " + _policies[i].checkinBeginTime + '. ';
        }
        if (_policies[i].checkinEndTime.length > 0) {
            checkin += "Check-in ends at " + _policies[i].checkinEndTime + '.';
        }
        return d.div({
            className: 'policyText checkinAndCheckoutPolicy'
        }, checkin);
    };

    this.drawCheckoutPolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText checkoutPolicy'
        }, "Check-out time is " + _policies[i].checkoutTime);
    };
    
    this.drawCheckinMinAgePolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText checkinMinAgePolicy'
        }, "Guests must be at least " + _policies[i].checkinMinAge + " years old to check in.");
    };

    this.drawCheckinInstructionsPolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText checkinInstructionsPolicy'
        }, _policies[i].checkinInstructions);
    };

    this.drawCheckinSpecialInstructionsPolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText checkinSpecialInstructionsPolicy'
        }, "<b>Important:</b> " + _policies[i].checkinSpecialInstructions );
    };

    this.drawMandatoryHotelFeesPolicyHeader = function() {
        var d = _d;
        return d.div({
            className: 'policyHeader mandatoryHotelFeesPolicyHeader'
        }, "Mandatory Hotel Fees");
    };

    this.drawMandatoryHotelFeesPolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText mandatoryHotelFeesPolicy'
        }, _policies[i].mandatoryFees);
    };

    this.drawAdditionalInformationPolicyHeader = function() {
        var d = _d;
        return d.div({
            className: 'policyHeader additionalInformationPolicyHeader'
        }, "Additional Information");
    };

    this.drawKnowBeforeYouGoPolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText knowBeforeYouGoPolicy'
        }, _policies[i].knowBeforeYouGo);
    };
    
    this.drawPetPolicy = function(i) {
        var d = _d;
        var petPolicies = d.div({
            className: 'policyText petPolicy'
        }, '');
        for (var policy in _policies[i].petPolicies) {
            petPolicies.append(
                d.div({
                    className: 'petPolicyText'
                }, _policies[i].petPolicies[policy])
            );
        }
        return petPolicies;
    };

    this.drawGeneralPolicy = function(i) {
        var d = _d;
        var generalPolicies = d.div({
            className: 'policyText generalPolicy'
        }, '');
        for (var policy in _policies[i].generalPolicies) {
            generalPolicies.append(
                d.div({
                    className: 'generalPolicyText'
                }, _policies[i].generalPolicies[policy])
            );
        }
        return generalPolicies;
    };

    this.drawOptionalExtrasPolicyHeader = function() {
        var d = _d;
        return d.div({
            className: 'policyHeader optionalExtrasPolicyHeader'
        }, "Optional Extras");
    };

    this.drawOptionalExtrasPolicy = function(i) {
        var d = _d;
        return d.div({
            className: 'policyText optionalExtrasPolicy'
        }, _policies[i].optionalFees);
    };

    var _d = jQuery.dom.getContext(this);

}, {
    WUID : 'CRAP',
    widgetName : 'GDSPoliciesWidget',
    imgPath : '/resources/img',
    subclass : false,
    policies : { }
});